import React from "react";
import { BackgroundImage, TeethLogo } from "../../Components";
import egyptImg from "../../assets/Images/why-egypt.jpg"

const Egypt = (props) => {
    const { selectedLanguage } = props

    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.txt_why_egypt} text={selectedLanguage?.txt_Treat_your_teeth_and_visite_egypt} mainClass='egypt-banner' />
            <TeethLogo heading={selectedLanguage?.txt_why_egypt} text1={selectedLanguage?.txt_pay_the_same_you_would_pay} />
            <div className="sterilization-component-container">
                <div className="sterilization-img-div">
                    <img src={egyptImg} alt="" />
                </div>
                <div className="egypt-bottom-text-div">
                    <p>{selectedLanguage?.txt_this_means_overhead_labor_costs}</p>
                    <p>{selectedLanguage?.txt_objective_is_to_offer_the_total}</p>
                </div>
            </div>
        </div>
    )
}

export default Egypt